import { GridValidRowModel } from "@mui/x-data-grid";
import { TableComponent } from "..";
import { ITableComponentProps } from "../model/types";
import TablePageLayout, { ITablePageLayoutProps } from "./TablePageLayout";

interface IExportStates {
  handleExportDraftReport?: () => void;
  isExporting?: boolean;
  isSavingAll?: boolean;
  hasChanges?: boolean;
  isBonusesCalculated?: boolean;
}

interface ITablePageProps extends ITablePageLayoutProps, ITableComponentProps {
  disableCellSelectionOnClick?: boolean;
  exportStates?: IExportStates;
}

export function TablePage<T extends GridValidRowModel>({
  disableCellSelectionOnClick,
  title,
  tableSearchModel,
  tableFilterModel,
  tableSortModel,
  onAddClick,
  onSettingsClick,
  hideTablePageHeader,
  disableTablePageHeader,
  tabsOptions,
  allowedAgencies,
  tabsValue,
  handleTabsChange,
  tableMenuModel,
  paginationMode = "server",
  sx,
  exportStates,
  ...tableComponentProps
}: ITablePageProps) {
  return (
    <TablePageLayout
      title={title}
      tableSearchModel={tableSearchModel}
      tableFilterModel={tableFilterModel}
      tableSortModel={tableSortModel}
      hideTablePageHeader={hideTablePageHeader}
      onAddClick={onAddClick}
      onSettingsClick={onSettingsClick}
      disableTablePageHeader={disableTablePageHeader}
      sx={sx}
      tabsOptions={tabsOptions}
      tabsValue={tabsValue}
      allowedAgencies={allowedAgencies}
      handleTabsChange={handleTabsChange}
      tableMenuModel={tableMenuModel}
      exportStates={exportStates}
    >
      <TableComponent<T>
        {...tableComponentProps}
        className={[
          tableComponentProps.className,
          disableCellSelectionOnClick ? "no-cell-selection" : null,
        ]
          .filter(Boolean)
          .join(" ")}
        paginationMode={paginationMode}
      />
    </TablePageLayout>
  );
}
